<ejs-dialog #locationConfigModal
			cssClass="modal-sm"
			(close)="closeModal(false)">
	<ng-template #header>
		@if (!isCreating) {
			<div class="dlg-template" [attr.data-test-id]="'locationConfigurationModalEditTitleBar'">Edit Location Configuration</div>
		}
		@if (isCreating) {
			<div class="dlg-template" [attr.data-test-id]="'locationConfigurationModalNewTitleBar'">New Location Configuration</div>
		}
	</ng-template>
	<ng-template #content>
		<form #componentForm="ngForm"
			  [formGroup]="formGroup"
			  (ngSubmit)="saveChanges()">
			<div class="card-body">
				<div class="row">
					@if (formGroup.invalid && componentForm.submitted) {
						<gandalf-lib-validation-messages
							[form]="formGroup"
							[requestObj]="createOrUpdateRequest"
							[attr.data-test-id]="'locationConfigurationModalValidation'">
						</gandalf-lib-validation-messages>
					}
					<div class="row mb-3">
						<label class="col-md-5 col-form-label required">Location</label>
						<div class="col-md-7">
							<ejs-dropdownlist revOverrideDropdownlistBase
											  [dataSource]="locationsList"
											  [fields]="{text: 'name', value: 'id' }"
											  formControlName="practiceLocationId"
											  [allowFiltering]="shouldFilter(locationsList)">
							</ejs-dropdownlist>
						</div>
					</div>
					<div class="row mb-3">
						<label class="col-md-5 col-form-label">Account #</label>
						<div class="col-md-7">
							<input type="text" class="e-input" formControlName="accountNumber"/>
						</div>
					</div>
					<div class="row mb-3">
						<label class="col-md-5 col-form-label">External/Ship-To #</label>
						<div class="col-md-7">
							<input type="text" class="e-input" formControlName="externalLocationId"/>
						</div>
					</div>
					<div class="row mb-3">
						<label class="col-md-5 col-form-label">Username</label>
						<div class="col-md-7">
							<input type="text" class="e-input" formControlName="userName"/>
						</div>
					</div>
					<div class="row mb-3">
						<label class="col-md-5 col-form-label">Password</label>
						<div class="col-md-7">
							<input type="text" class="e-input" formControlName="password"/>
						</div>
					</div>
				</div>
			</div>
		</form>
	</ng-template>
	<ng-template #footerTemplate>
		<button ejs-button iconCss="fa fa-times" type="button" (click)="closeModal(false)" [attr.data-test-id]="'locationConfigurationModalCancelButton'">
			Cancel
		</button>
		<button ejs-button isPrimary="true" type="submit" (click)="submitForm($event)" [attr.data-test-id]="'locationConfigurationModalSaveButton'">Save
		</button>
	</ng-template>
</ejs-dialog>
